import throttle from 'lodash.throttle';

class Clipping {
	init() {
		this.heroBgEllipse = document.querySelector('#m-hero-bg-curve-desktop ellipse');
		this.heroEllipse = document.querySelector('#m-hero-curve-desktop ellipse');
		this.ctaEllipse = document.querySelector('#m-cta-curve-desktop ellipse');

		window.addEventListener(
			'resize',
			throttle(() => {
				this.updateHeroBgPath();
				this.updateHeroPath();
				this.updateCtaPath();
			}, 100)
		);

		this.updateHeroBgPath();
		this.updateHeroPath();
		this.updateCtaPath();
	}

	calcPathAttributes() {
		const screenWidth = window.innerWidth;
		const originalScreenWidth = 1440;
		const originalRx = 1975;
		const originalRy = 870;

		return {
			cx: screenWidth / 2,
			rx: (screenWidth / originalScreenWidth) * originalRx,
			ry: (screenWidth / originalScreenWidth) * originalRy,
		};
	}

	updateHeroBgPath() {
		const breakpoint = window.matchMedia('(min-width: 992px)');

		if (!this.heroBgEllipse) {
			return;
		}

		if (!breakpoint.matches) {
			return;
		}

		const { cx, rx, ry } = this.calcPathAttributes();

		this.heroBgEllipse.setAttribute('cx', Math.floor(cx));
		this.heroBgEllipse.setAttribute('rx', Math.floor(rx));
		this.heroBgEllipse.setAttribute('ry', Math.floor(ry));

		const ryInt = parseInt(this.heroBgEllipse.getAttribute('ry'));
		const newCy = window.innerHeight - ryInt;

		this.heroBgEllipse.setAttribute('cy', newCy);
	}

	updateHeroPath() {
		if (!this.heroEllipse) {
			return;
		}

		const { cx, rx, ry } = this.calcPathAttributes();

		this.heroEllipse.setAttribute('cx', Math.floor(cx));
		this.heroEllipse.setAttribute('rx', Math.floor(rx));
		this.heroEllipse.setAttribute('ry', Math.floor(ry));
		this.heroEllipse.setAttribute('cy', Math.floor(ry));
	}

	updateCtaPath() {
		if (!this.ctaEllipse) {
			return;
		}

		const { cx, rx, ry } = this.calcPathAttributes();

		this.ctaEllipse.setAttribute('cx', Math.floor(cx));
		this.ctaEllipse.setAttribute('rx', Math.floor(rx));
		this.ctaEllipse.setAttribute('ry', Math.floor(ry));

		const ryInt = parseInt(this.ctaEllipse.getAttribute('ry'));
		const newCy = 100 - ryInt;

		this.ctaEllipse.setAttribute('cy', newCy);
	}
}

export const clipping = new Clipping();
